// @flow

import React from 'react';
import Button from '@mui/material/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import ForwardRef from '../ForwardRef';

type Props = {
  id: String,
  url: string,
  onClick: Function,
  label: String
};

const CdaButton = ({ id, url, label, onClick }: Props) => {
  const updateWindowHistory = () => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('cdaViewerUrl', url);
    window.history.replaceState({}, '', currentUrl);
  };

  const handleClick = () => {
    updateWindowHistory();
    onClick();
  };

  return (
    <Button
      variant="outlined"
      id={`cda-${id}`}
      className="!mr-2 !leading-none !py-[5px] !px-1 !text-[1.05rem] 
      !text-black !font-semibold rounded !border-mineShaft/40
       [&.Mui-disabled]:!bg-black/10 [&.Mui-disabled]:!text-gray-500 
       lg:text-[0.9rem] lg:py-[10px] lg:px-2 md:text-[0.8rem] md:py-1 md:px-2"
      onClick={handleClick}
    >
      <>{label}</>
      <ForwardRef>
        <FontAwesomeIcon icon={solid('external-link')} className="mx-1" />
      </ForwardRef>
    </Button>
  );
};

export default CdaButton;
